import authActions from './authActions';
import userActions from './userActions';

export default { authActions, userActions };
